import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

export const COMPANY_PROFILE_EXPORT_PARAMETERS_VERSION = 1;
export const INSTALLS_DATA_POINTS_LIMIT = 25_000;
export const EXPORT_FORMAT_XLSX = "XLSX";
export const EXPORT_FORMAT_PDF = "PDF";
export enum ExportFailureReason {
  FILE_TOO_LARGE_INSTALL = "FILE_TOO_LARGE_INSTALL",
}
export const SUPPORT_EMAIL = "customersupport@hginsights.com";
// Export Dialog Messages
export const EXPORT_MESSAGES = {
  // Loading messages
  LOADING: {
    VALIDATING: "Validating export request...",
    PROCESSING: "Processing export request...",
    PROCESSING_SUBTITLE:
      "Your report will be delivered to your inbox within a few minutes.",
  },

  // Error messages
  ERROR: {
    TITLE: "Export request failed",
    FILE_TOO_LARGE:
      "The export contains more than 25,000 Installs data points, exceeding the maximum size. We recommend refining the Install filters to narrow your search results.",
    GENERIC: (
      <Typography variant="body2">
        An unexpected error occurred while processing your request. Please try
        again later. If the issue persists, please contact{" "}
        <Link href={`mailto:${SUPPORT_EMAIL}`} underline="hover">
          {SUPPORT_EMAIL}
        </Link>
        .
      </Typography>
    ),
  },

  // Success messages
  SUCCESS: {
    getMessage: (email: string) =>
      `The requested report is being processed and will be delivered to your inbox (${email}) shortly.`,
  },

  // Dialog content
  DIALOG: {
    TITLE: "Company Export",
    DESCRIPTION:
      "Your report will be delivered to your inbox within a few minutes.",
    SUPPORT_TEXT:
      "If you have any questions or need additional data, please contact",
    SUPPORT_EMAIL,
  },

  // Button labels
  BUTTONS: {
    CANCEL: "CANCEL",
    EXPORT: "EXPORT TO EXCEL",
    CLOSE: "CLOSE",
  },
} as const;
